<script setup>
import { onMounted, onUpdated } from 'vue';
import { t } from '@/i18n';
import { useRoute } from 'vue-router';

const route = useRoute();

const props = defineProps({
  title: {
    type: String,
    default: t('landing.seoTitle'),
  },
  description: {
    type: String,
    default: t('landing.seoDescription'),
  },
  keywords: {
    type: String,
    default: t('landing.seoKeywords'),
  },
  image: {
    type: String,
    default: 'https://seede.ai/images/screenshot.png',
  },
});

onUpdated(render);

function render() {
  // Update document title
  document.title = props.title;

  // Update meta tags
  const metaElements = document.getElementsByTagName('meta');
  for (let i = 0; i < metaElements.length; i++) {
    const metaElement = metaElements[i];
    if (
      metaElement.getAttribute('property') === 'og:title' ||
      metaElement.getAttribute('name') === 'twitter:title'
    ) {
      metaElement.setAttribute('content', props.title);
    } else if (metaElement.getAttribute('name') === 'description') {
      metaElement.setAttribute('content', props.description);
    } else if (metaElement.getAttribute('name') === 'keywords') {
      metaElement.setAttribute('content', props.keywords);
    } else if (
      metaElement.getAttribute('property') === 'og:image' ||
      metaElement.getAttribute('name') === 'twitter:image'
    ) {
      metaElement.setAttribute('content', props.image);
    }
  }

  // Add canonical link
  let canonicalUrl = `https://seede.ai${route.path}`;
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', canonicalUrl);
}

onMounted(() => {
  render();
});
</script>

<template></template>
